// Generated from source/ by scripts/generate.ts. Do not edit by hand.
import type { IconData } from "../types.js";

const m0 =
  '<path d="M11 13H6Q5.58 13 5.29 12.71T5 12 5.29 11.29 6 11H11V6Q11 5.58 11.29 5.29T12 5 12.71 5.29 13 6V11H18Q18.42 11 18.71 11.29T19 12 18.71 12.71 18 13H13V18Q13 18.42 12.71 18.71T12 19 11.29 18.71 11 18Z"/>';

/** Plus (actions). */
const icon: IconData = {
  id: "plus",
  name: "Plus",
  category: "actions",
  styles: {
    rounded: { svg: m0 },
    sharp: { svg: '<path d="M11 13H5V11H11V5H13V11H19V13H13V19H11Z"/>' },
    outline: { svg: m0 },
    duotone: {
      svg: '<g opacity=".32"><path d="M11 13H6Q5.58 13 5.29 12.71T5 12 5.29 11.29 6 11H11V6Q11 5.58 11.29 5.29T12 5 12.71 5.29 13 6V11H18Q18.42 11 18.71 11.29T19 12 18.71 12.71 18 13H13V18Q13 18.42 12.71 18.71T12 19 11.29 18.71 11 18Z"/></g><path d="M11 13H6Q5.58 13 5.29 12.71T5 12 5.29 11.29 6 11H11V6Q11 5.58 11.29 5.29T12 5 12.71 5.29 13 6V11H18Q18.42 11 18.71 11.29T19 12 18.71 12.71 18 13H13V18Q13 18.42 12.71 18.71T12 19 11.29 18.71 11 18Z"/>',
    },
  },
  animation: () => import("../animations/plus.js"),
};

export default icon;
